<div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
      <div style="width:440px;">
        <div class="flexStart">
          <p class="tileTitle" style="margin-bottom: 5px;">{{'User Activity Overview' | translate}}</p>
          <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
        </div>
         <!--  <ng-container *ngIf="data_01?.length">
          <div style="text-align: center;margin-top: 20px;" id="userActivityChart" [ctlDonutChart]='settings_01' [ctlData]='data_01' [fontSize]='fontBig'>
          </div> 
        </ng-container> -->
       <div style="margin-left:50px" class="padT30"> 
       
        <div class="text" *ngIf="data_01.length==0" [ngClass]="data_01.length==0 ? 'padR85':''" [dir]="textDir">{{'No data' | translate}}</div>
        <div class="chartContainer" disabled [ngClass]="data_01.length==0 ? 'chartDisabled':''">          
        <div id="totaldonut1" >{{'Chart' | translate}}</div>
      </div>
      </div>
      </div>


      <div style="padding-right: 40px;">
      <ng-container *ngFor="let user of data_01_01; let i = index">
        <div class="userCntDetails" style="margin-top: 20px;">
          <div class="header" style="height:30px;">
            <!-- <div style="font-size: 13px;">
              <span style="margin-right:5px;" [style.color]="settings_01?.colors[i]">
                <i class="icon icon-alarm-level5"></i>
              </span>
              {{user?.role}}
            </div> -->
            <div style="margin-right: 0px;margin-left:0px;display: inline;">
              <div style="display: inline; font-size: 18px;"  class="{{'colorData-'+(i+1)}}"><i class="icon icon-alarm-level5"></i></div> <div class="devices" style="display: inline;" [dir]="textDir">{{user?.role}}</div>
            </div> 
          </div>
        
          <div class="content" style="display: inline-block;" [dir]="textDir">
            <div class="deviceCount" >
              <div class="usersUsage">
                <p class="devicesCnt" *ngIf="!isNaN(user?.total)">{{user?.total || 0}}</p>   <p class="devices">{{'Logins' | translate}}</p> 
                
              </div>
              <div class="usersUsage">
                <p class="devicesCnt" *ngIf="!isNaN(user?.Tablet)">{{user?.Tablet || 0}}%</p><p class="devices">{{'Tablets' | translate}}</p>  
              </div>
              <div class="usersUsage">
                <p class="devicesCnt" *ngIf="!isNaN(user?.Laptop)">{{user?.Laptop|| 0}}%</p> <p class="devices">{{'Laptops' | translate}}</p>
              </div>
            </div>
            <hr *ngIf="i < data_01_01.length" class="marT20">
          </div> 
        </div>
      </ng-container>
     
    </div>
      <!-- <div style="width:45%;margin-left: 10px;">
          <ng-container *ngFor="let user of data_01_01; let i = index">
            <div class="userCntDetails" style="margin-top: 20px;">
              <div class="header" style="height:30px;">
              
                <div style="margin-right: 0px;margin-left:0px;display: inline;">
                  <div style="display: inline; font-size: 18px;"  [style.color]="settings_01?.colors[i]"><i class="icon icon-alarm-level5"></i></div> <div class="devices" style="display: inline;" >{{user?.role}}</div>
                </div> 
              </div>
              <div class="content" style="display: inline-block;">
                <div class="deviceCount" >
                  <div class="usersUsage">
                    <p class="devicesCnt">{{user?.total || 0}}</p>   <p class="devices">Logins</p> 
                  </div>
                  <div class="usersUsage">
                    <p class="devicesCnt">{{user?.Tablet || 0}}%</p><p class="devices">Tablets</p>  
                  </div>
                  <div class="usersUsage">
                    <p class="devicesCnt">{{user?.Laptop|| 0}}%</p> <p class="devices">Laptops</p>
                  </div>
                </div>
                <hr *ngIf="i < data_01_01.length">
              </div> 
            </div>
          </ng-container>
      </div> -->
    </div>
      <div style="width: 20px;margin-top: 2px;text-align: right;">
          <div #useractivitydrop class="dropdown more" data-type="click">
              <button class="btn clickable"><i class="icon icon-more"></i></button>
              <div class="menu right">
                <div class="item" tabindex="0" (click)="generateCSV('users-activity')">{{'Export Panel Data(csv)' | translate}}</div>
<!--                 <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)' | translate}}</div>
 -->               
              </div>
            </div>
      </div>
  </div>
</div>
<br>
<div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">

  <div class="sm-11">
       <div class="flexStart">
          <p class="tileTitle" style="margin-bottom: 5px;">{{'User Activity Trend' | translate}}</p>
          <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
         </div>
          <ng-container >
            
          <div style="display: inline-block;width:100%;min-width:700px;">
          

         <!--    <div id="default-line-chart">Chart</div> -->
            <div class="text" *ngIf="userTrendChartData.length==0" >{{'No data' | translate}}</div>
        <div class="chartContainer" disabled [ngClass]="userTrendChartData.length==0 ? 'chartDisabled':''">          
        <div id="default-line-chart" >{{'Chart' | translate}}</div>
      </div>
          </div>
        </ng-container>
      </div>

      <div style="width: 20px;text-align: center;margin-top: 2px;">
        <div #usertrenddrop class="dropdown more" data-type="click">
            <button class="btn clickable" style="min-width:20px !important;"><i class="icon icon-more"></i></button>
            <div class="menu right">
              <div class="item" tabindex="0" (click)="generateCSV('users-trend')">{{'Export Panel Data(csv)' | translate}}</div>
<!--               <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)' | translate}}</div>
 -->              <!-- <hr>
              <div class="item space-between">
                <div>Settings</div>
                <div><i class="icon icon-settings"></i></div>
              </div> -->
            </div>
          </div>
    </div>
</div>

</div>
<br>
<div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
      <div style="width: 440px;">
          <p class="tileTitle">{{'Registered Users' | translate}}</p>
         <!--  <ng-container *ngIf="data02?.length">
          <div style="text-align: center;margin-top: 50px;" id="registeredUsersChart" [ctlDonutChart]='settings02' [ctlData]='data02' [fontSize]='fontBig'>
          </div> 
        </ng-container> -->
        <div style="margin-left:50px" class="padT30"> 
        
        <div class="text" *ngIf="data02.length==0" [ngClass]="data02.length==0 ? 'padR85':''" [dir]="textDir">{{'No data' | translate}}</div>
        <div class="chartContainer" disabled [ngClass]="data02.length==0 ? 'chartDisabled':''">          
        <div id="totaldonut2" >{{'Chart' | translate}}</div>
      </div>
        </div>
      </div>

      <div style="width:45%;margin-left: 20px;">
          <ng-container *ngFor="let user of regusers; let i = index">
            <div class="userCntDetails" style="margin-top: 20px;">
              <div class="header" style="height:30px;">
               <!--  <div style="font-size: 13px;">
                  <span style="margin-right:5px;" [style.color]="settings02?.colors[i]">
                    <i class="icon icon-alarm-level5"></i>
                  </span>
                  {{user?.role}}s
                </div> -->
                <div style="margin-right: 0px;margin-left:0px;display: inline;">
                  <div style="display: inline; font-size: 18px;"  class="{{'colorData-'+(i+1)}}"><i class="icon icon-alarm-level5"></i></div> <div class="devices" style="display: inline;" [dir]="textDir">{{user?.role}}s</div>
                </div> 
              </div>
              <div class="content" style="display: inline-block;" [dir]="textDir">
                <div class="deviceCount" >
                  <div class="usersUsage">
                    <p class="devicesCnt" *ngIf="!isNaN(user?.registered)">{{user?.registered || 0}}</p>   <p class="devices">{{'Registered'|translate}}</p> 
                  </div>
                  <div class="usersUsage">
                    <p class="devicesCnt" *ngIf="!isNaN(user?.active)">{{user?.active || 0}}%</p><p class="devices">{{'Active'|translate}}*</p>
                  </div>
                </div>
                <hr *ngIf="i < regusers?.length" class="marT20">
              </div> 
            </div>
          </ng-container>
          <div class="usersUsage"><p class="devicesCnt" style="color:#f2f2f2;float: right;padding:10px 0px;opacity: 0.6;">*{{'within the filter time period' | translate}}</p></div>
      </div>
    </div>
      <div style="width: 20px;">
          <div #totaluserdrop class="dropdown more" data-type="click">
              <button class="btn clickable"><i class="icon icon-more"></i></button>
              <div class="menu right">
                <div class="item" tabindex="0" (click)="generateCSV('total-users')">{{'Export Panel Data(csv)'|translate}}</div>
               <!--  <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)'|translate}}</div> -->
                <!-- <hr>
                <div class="item space-between">
                  <div>Settings</div>
                  <div><i class="icon icon-settings"></i></div>
                </div> -->
              </div>
            </div>
      </div>
  </div>
</div>
<br>
<div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
      <div style="width: 440px;">
        <div class="flexStart">
          <p class="tileTitle" style="margin-bottom: 5px;">{{'New Registered Users'|translate}} </p>
          <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
         </div>
          <!--  <ng-container *ngIf="data03?.length">
          <div style="text-align: center;margin-top: 50px;" id="newUsersChart" [ctlDonutChart]='settings03' [ctlData]='data03' [fontSize]='fontBig'>
          </div>
        </ng-container> -->
        <div style="margin-left:50px" class="padT30"> 
        
        <div class="text" *ngIf="data03.length==0" [ngClass]="data03.length==0 ? 'padR85':''" [dir]="textDir">{{'No data'|translate}}</div>
        <div class="chartContainer" disabled [ngClass]="data03.length==0 ? 'chartDisabled':''">          
        <div id="totaldonut3" >{{'Chart'|translate}}</div>
      </div>
        </div>
       
      </div>

      <div style="width:45%;margin-left: 20px;">
          <ng-container *ngFor="let user of newusers; let i = index">
            <div class="userCntDetails" style="margin-top: 20px;">
              <div class="header" style="height:30px;">
               <!--  <div style="font-size: 13px;">
                  <span style="margin-right:5px;" [style.color]="settings03?.colors[i]">
                    <i class="icon icon-alarm-level5"></i>
                  </span>
                  {{user?.role}}s
                </div> -->
                <div style="margin-right: 0px;margin-left:0px;display: inline;">
                  <div style="display: inline; font-size: 18px;" class="{{'colorData-'+(i+1)}}"><i class="icon icon-alarm-level5"></i></div> <div class="devices" style="display: inline;" [dir]="textDir" >{{user?.role}}s</div>
                </div>
              </div>
              <div class="content" style="display: inline-block;" [dir]="textDir">
                <div class="deviceCount" >
                  <div class="usersUsage">
                    <p class="devicesCnt" *ngIf="!isNaN(user?.registered)">{{user?.registered || 0}}</p>   <p class="devices">{{'Registered'|translate}}</p> 
                  </div>
                  <div class="usersUsage">
                    <p class="devicesCnt" *ngIf="!isNaN(user?.active)">{{user?.active || 0}}%</p><p class="devices">{{'Active'|translate}}*</p>
                  </div>
                </div>
                <hr *ngIf="i < regusers?.length" class="marT20">
              </div> 
            </div>
          </ng-container>
          <div class="usersUsage"><p class="devicesCnt" style="color:#f2f2f2;float: right;padding:10px 0px;opacity: 0.6;">*{{'within the filter time period' | translate}}</p></div>
      </div>
    </div>
      <div style="width: 20px;">
          <div #newuserdrop class="dropdown more" data-type="click">
              <button class="btn clickable"><i class="icon icon-more"></i></button>
              <div class="menu right">
                <div class="item" tabindex="0" (click)="generateCSV('new-users')">{{'Export Panel Data(csv)'|translate}}</div>
               <!--  <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)'|translate}}</div> -->
                <!-- <hr>
                <div class="item space-between">
                  <div>Settings</div>
                  <div><i class="icon icon-settings"></i></div>
                </div> -->
              </div>
            </div>
      </div>
  </div>
</div>
